<template>
  <div class="dropdown">
    <button class="lang-select" @click="toggle">
      <cms-material-icon class="icon lang-select" icon="language"></cms-material-icon>
      {{ language_map[$language.current] }}
    </button>
    <div ref="drops" class="dropdown-content">
      <router-link v-for="l in link_options" :to="l" :key="l.path"> {{ language_map[l.params.language] }}</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "cms-lang-switch",
  computed: {
    link_language() {
      if (this.$route.name == "storyblok_cms_catch_all") {
        return [
          { path: `/en/${this.$route.params.pathMatch}`, params: { ...this.$route.params, language: 'en' }, query: this.$route.query },
          { path: `/de/${this.$route.params.pathMatch}`, params: { ...this.$route.params, language: 'de' }, query: this.$route.query },
          { path: `/fr/${this.$route.params.pathMatch}`, params: { ...this.$route.params, language: 'fr' }, query: this.$route.query },
          { path: `/it/${this.$route.params.pathMatch}`, params: { ...this.$route.params, language: 'it' }, query: this.$route.query },
        ];
      }
      return [
        { name: this.$route.name, params: { ...this.$route.params, language: 'en' }, query: this.$route.query },
        { name: this.$route.name, params: { ...this.$route.params, language: 'de' }, query: this.$route.query },
        { name: this.$route.name, params: { ...this.$route.params, language: 'fr' }, query: this.$route.query },
        { name: this.$route.name, params: { ...this.$route.params, language: 'it' }, query: this.$route.query },
      ]
    },
    link_options() {
      return this.link_language.filter(l => l.params.language != this.$route.params.language)
    }
  },
  methods: {
    toggle() {
      this.$refs.drops.classList.toggle("show");
    }
  },
  mounted() {
    window.onclick = function (event) {
      if (!event.target.matches('.lang-select')) {
        var dropdowns = document.getElementsByClassName("dropdown-content");
        var i;
        for (i = 0; i < dropdowns.length; i++) {
          var openDropdown = dropdowns[i];
          if (openDropdown.classList.contains('show')) {
            openDropdown.classList.remove('show');
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.dropdown {
  position: relative;
  display: block;
}

/* Dropdown Button */
button {
  color: var(--crf-text);
  font-size: 0.9rem;
  display: flex;
  gap: 2px;
  align-items: center;
  background-color: transparent;
  border: none;
  cursor: pointer;
  margin: 0;
  padding: 0;
}

button span.icon {
  font-size: 20px;
  font-variation-settings: 'OPSZ' 20;
}

/* Dropdown button on hover & focus */
button:hover span.icon,
button:focus span.icon {
  color: var(--crf-accent);
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: none;
  overflow: hidden;
  position: absolute;
  top: -120px;
  background-color: var(--crf-bg-high);
  min-width: fit-content;
  border-radius: 10px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

/* Links inside the dropdown */
.dropdown-content a {
  color: var(--crf-text);
  font-size: 0.9rem;
  padding: 8px 15px;
  text-decoration: none;
  display: block;
}

.dropdown-content a:hover {
  color: var(--crf-accent);
}

.show {
  display: block;
}
</style>
